import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import FeesBreakdownDetailsIcon from './fees-breakdown-details';
import money, { format } from '../../../lib/money';

class YourShareMinContribution extends Component {
  get shareAmount() { return money(this.props.shareAmount); }

  renderFeesBreakdownDetails() {
    const { feesAmount, costPerSlot, claimedSlots, amount } = this.props;

    return (
      <FeesBreakdownDetailsIcon
        claimedSlots={claimedSlots}
        amount={amount}
        shareAmount={this.shareAmount}
        costPerSlot={costPerSlot}
        feesAmount={feesAmount}
      />
    );
  }

  get label() {
    return (
      <FormattedMessage
        id="yourShare.minContribution.yourShare"
        defaultMessage="Your share"
      />
    );
  }

  render() {
    return (
      <div className="your-share-min-contribution">
        <div>
          {this.label} {this.renderFeesBreakdownDetails()}
        </div>
        <div>
          <h2>{format(this.shareAmount)}</h2>
          <p className="small-print">
            <FormattedMessage
              id="yourShare.minContribution.recommendedContribution"
              defaultMessage="recommended contribution"
            />
          </p>
        </div>
      </div>
    );
  }
}

export default YourShareMinContribution;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/your-share.min-contribution.js